//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = (rule, cb) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.ClientLSTranslator', 'inited', (p, widget) => {
			const master_sendPaidShowRequest = widget.sendPaidShowRequest;

			widget.sendPaidShowRequest = (data, ...args) => callback().then(({ result, params }) => {
				if (result === true) {
					return master_sendPaidShowRequest.apply(widget, [
						{
							...data,
							...params
						},
						...args
					]);
				}

				return [];
			});
		}, {
				sync: true,
				prefix: 'user_access_patch_liveshow_translator'
			});
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-liveshow-translator.es.js